import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=6b0aa044&scoped=true"
import script from "./UserEditProfile.vue?vue&type=script&lang=js"
export * from "./UserEditProfile.vue?vue&type=script&lang=js"
import style0 from "./UserEditProfile.vue?vue&type=style&index=0&id=6b0aa044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0aa044",
  null
  
)

export default component.exports